import transform from 'lodash/transform';
import isEqual from 'lodash/isEqual';
import isObject from 'lodash/isObject';
import { THEME_CONFIG } from '../webim-style-select/conf';

// 将菜单序号、placeholder重置
export function resetMenuSNData(list = []) {
    list.forEach((item, index) => {
        item.value = index;
        item.placeholder = '按钮' + (index + 1);
    });
};
// 对获取到的数据进行简单处理
export const formatStyleData = function (data = {}) {
    if (!data.styleConfig) {
        const theme = data.theme || 1;

        data.styleConfig = {
            themeColor: `#${THEME_CONFIG[theme].color}`,
            backgroundImage: {
                pc: '',
                mobile: '',
            },
        };
    }

    if (!data.styleConfig.themeColor) {
        data.styleConfig.themeColor = `#${THEME_CONFIG[data.theme]}`;
    }

    if (!data.styleConfig.backgroundImage) {
        data.styleConfig.backgroundImage = {
            pc: '',
            mobile: '',
        };
    }

    // 大模型气泡导航需求中，设计师拆分了客户引流部分，导致同一份数据要拆开在两个组件中使用。。。。
    // 引流数据
    data.guidanceInfoForYinliu = {};
    // 客户互动数据
    data.guidanceInfoForHudong = {};
    if (data.guidanceInfo) {
        const { guidanceData, guidanceQQ, guidanceQQType, guidanceWechat, ...otherData } = data.guidanceInfo;

        data.guidanceInfoForYinliu = { guidanceData, guidanceQQ, guidanceQQType, guidanceWechat };

        data.guidanceInfoForHudong = { ...otherData };

        // 清理
        data.guidanceInfo = undefined;
    }

    // 转换气泡导航数据
    if (data.navInfo) {
        // navStatus： 1-启用，2-禁用，默认禁用
        const { navStatus = 2, navData = {} } = data.navInfo;
        const { name = '', color = '', menuJson = '', ...otherData } = navData;

        // 解析数据
        try {
            const prasedColor = JSON.parse(color);
            const parsedMenu = JSON.parse(menuJson);

            try {
                resetMenuSNData(parsedMenu.content.menu.list);
            } catch (ex) {
                
            }
            
            const interactiveNavData = {
                ...otherData,
                enableSwitch: +navStatus === 1, // 1 启用，2 禁用
                name,
                color: prasedColor,
                menu: parsedMenu.content.menu,
            };

            // 气泡导航数据加入到互动数据中
            data.guidanceInfoForHudong = { ...data.guidanceInfoForHudong, interactiveNavData };
        } catch (ex) { }
        
        data.navInfo = undefined;
    }

    return data;
};

/** 反向数据转换为提交数据 */
export function convertStyleDataForSubmit(data = {}) {

    const { interactiveNavData, ...otherHudongData } = data.guidanceInfoForHudong || {};
    // 转换气泡导航数据
    if (interactiveNavData) {
        const { enableSwitch, color, menu, ...otherData } = interactiveNavData;
        if (menu.list) {
            menu.list.forEach((item) => {
                // 删除无用数据
                delete item.value;
                delete item.error;
            });
        }
        const navData = {
            ...otherData,
            color: JSON.stringify(color),
            menuJson: JSON.stringify({ content: { menu } }),
        }
        data.navInfo = {
            navStatus: enableSwitch ? 1 : 2, // 1 启用，2 禁用
            navData,
        };
    }

    // 整理原 guidanceInfo 数据
    data.guidanceInfo = { ...data.guidanceInfoForYinliu, ...otherHudongData };

    // 清理数据
    data.guidanceInfoForHudong = undefined;
    data.guidanceInfoForYinliu = undefined;

    return data;
};

export const isSameObj = function (object, base) {
    const changes = (objects, bases) => transform(objects, (result, value, key) => {
        if (!isEqual(value, bases[key])) {
            result[key] = isObject(value) && isObject(base[key]) ? changes(value, base[key]) : value;
        }
    });
    return JSON.stringify(changes(object, base)) === '{}';
};

export const authorizeTipDefault = {
    title: '是否允许访问您设备上的相册和文件？',
    explain: '允许后可上传图片及文件，提高沟通效率',
};
export const CHATWINDOWSYSTEMEVENTTIPKEY = 'CHATWINDOWSYSTEMEVENTTIPKEY';
export default {};
